export default {
  loading: {
    id: 'buyback_step_device_loading',
    defaultMessage: 'Loading',
  },
}
